<template>
  <v-tooltip bottom :open-delay="500" :color="'rgba(0,0,0,0.8)'">
    <template v-slot:activator="{ on, attrs }">
      <v-sheet
        v-bind="attrs"
        :class="[`th-${metric.color}`, `${metric.key}-filial-metric`]"
        class="bar-sheet a-center"
        height="60"
        width="auto"
        v-on="on"
      >
        <div class="d-flex flex-column">
          <span class="d-block">
            <span class="count count-primary">{{ primaryValue }}</span>
            <span
              v-if="isRange && !bothZero"
              class="count"
            >/{{ totalValue }}</span>
          </span>
          <span>{{ metric.title }}</span>
        </div>
      </v-sheet>
    </template>
    {{ metric.description }}
  </v-tooltip>
</template>

<script>
  export default {
    name: 'FilialMetric',
    props: {
      metric: Object,
    },
    computed: {
      isRange () {
        return Array.isArray(this.metric.value) && this.metric.value.length === 2
      },
      bothZero () {
        return (
          this.isRange &&
          Number(this.metric.value[0]) === 0 &&
          Number(this.metric.value[1]) === 0
        )
      },
      primaryValue () {
        if (this.bothZero) return '---'
        return this.isRange ? this.metric.value[0] : this.metric.value || '---'
      },
      totalValue () {
        return this.isRange ? this.metric.value[1] : null
      },
    },
  }
</script>

<style lang="less" scoped>
.bar-sheet {
  display: flex;
  flex-shrink: 0;
  background-color: @color-secondary;
  padding: 12px;
  border-radius: 5px;
  margin-right: 10px;

  span {
    font-size: 11px;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
  }

  .count {
    font-size: 15px;
    font-weight: bold;
    white-space: nowrap;
    line-height: 29px;
  }

  // &.th-empty {
  //   .count-primary {
  //     color: #ccc;
  //   }
  // }

  &.th-green {
    .count-primary {
      color: #6bad00;
    }
  }

  &.th-yellow {
    .count-primary {
      color: #ff9100;
    }
  }

  &.th-red {
    .count-primary {
      color: #e91e63;
    }
  }

  .media-sm({
      justify-content: center;
      margin: 0;
      flex-basis: 33%;
      width: 33%;

      .count {
        font-size: 24px;
      }

      span {
        text-align: center;
      }

    });

  .media-xl({
      margin-right: 10px;
    });

  // компактный десктоп: плитки плотнее - ширина шапки отдана поиску
  .media-compact-pc({
    padding: 12px 8px;
    margin-right: 6px;
  });
}
</style>
